module.exports = __webpack_public_path__ + "img/fb19.f48f5185.jpg";